import { createAnalyticsGroup } from 'js/lib/analytics'

if (document.querySelectorAll('.js-c-pages-landing-help-need-to-rehome').length) {
  document.querySelectorAll('a').forEach(el => {
    const track = createAnalyticsGroup('HelpINeedToRehomeMyPet')

    const label =
    el.getAttribute('data-analytics-label') ||
    el.textContent.trim().replace(/\s+/g, ' ') || // fallback to text content
    'unknown link'
    
    el.addEventListener('click', () => {
      track('click', label)
    })
  })
}
